import { css } from '@emotion/react';
import styled from '@emotion/styled';

const FlexCenter = css`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

const Container = styled.section`
  display: flex;
  flex-direction: column;

  gap: 8px;
`;

const Header = styled.header`
  display: flex;
  flex-direction: column;

  gap: 16px;
`;

const Conteudo = styled.div<{ center?: boolean }>`
  display: flex;
  flex-direction: column;

  ${({ center }) => center && FlexCenter}

  gap: 32px;
`;

const ErroWrapper = styled.div`
  box-sizing: border-box;

  display: flex;
  ${FlexCenter}
`;

const ErroContent = styled.div`
  display: flex;
  flex-direction: column;
  ${FlexCenter}
  text-align: center;
  gap: 24px;

  margin: 40px 0 16px;
  max-width: 300px;
`;

const S = {
  Container,
  Header,
  Conteudo,
  ErroWrapper,
  ErroContent,
};

export default S;
